module.exports = __webpack_public_path__ + "img/jxk-banner.170a12f5.png";